module.exports = __webpack_public_path__ + "static/media/masters_thesis18.3e21ab0c.webp";